import strFunc from "@/lib/lyg/string";

function OptionArea(props: any) {
  let myProps = {
    make_option: {},
    set_make_option: (inData: any) => { },
    ...props
  };
  let make_option = myProps.make_option;

  const on_change_make_option = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    let tmp_make_option = { ...make_option };
    if (name == 'one_day_amount') {
      value = strFunc.uncomma_int(value);
    }
    tmp_make_option[name] = value;
    myProps.set_make_option(tmp_make_option);
  };

  return (
    <div className="text-center">
      <span>하루분량</span>
      <input type="text" value={make_option.one_day_amount} name="one_day_amount" onChange={on_change_make_option}
        className="row-input" style={{ width: 50,textAlign:"center" }} autoComplete="off" 
        onClick={(e:any)=>{e.target.select();}} />
    </div>
  );
};
export default OptionArea;